import React from "react";
import axios from "axios";

export default function WebappForm(props) {

	const x = props.x;
	const renderCount = React.useRef(1);

	// Zeiger auf Funktionen
	x.waf.checkChanged = checkChanged;
	x.waf.destroy = destroy;
	x.waf.disable = disable;
	x.waf.enable = enable;
	x.waf.focus = focus;
	x.waf.get = get;
	x.waf.getKey = getKey;
	x.waf.getValid = getValid;
	x.waf.hide = hide;
	x.waf.init = init;
	x.waf.initField = initField;
	x.waf.insert = insert;
	x.waf.insertText = insertText;
	x.waf.isField = isField;
	x.waf.isNewWord = isNewWord;
	x.waf.isReadOnly = isReadOnly;
	x.waf.mandatory = mandatory;
	x.waf.mandatoryOk = mandatoryOk;
	x.waf.select = select;
	x.waf.send = send;
	x.waf.set = set;
	x.waf.setFields = setFields;
	x.waf.setReadOnly = setReadOnly;
	x.waf.setReference = setReference;
	x.waf.setValid = setValid;
	x.waf.setAddSend = setAddSend;
	x.waf.setCursorPos = setCursorPos;
	x.waf.setKey = setKey;
	x.waf.setSource = setSource;
	x.waf.show = show;

	React.useEffect(() => {
		if (renderCount.current === 1) {
			props.childRendered();
		}
		renderCount.current++;
	});

	function destroy(wafId) {
		console.log('Destroy Webapp Form: ' + wafId);
		delete x.waf[wafId];
	}

	function init(wafId, settings) {
		if (typeof x.waf[wafId] === 'undefined') {
			// console.log('Init Webapp Form: ' + wafId);
			x.waf[wafId] = {};
			x.waf[wafId].onFormChanged = () => { };
			x.waf[wafId].onRead = () => { };
			x.waf[wafId].onAfterRead = () => { };
			x.waf[wafId].onBeforeRead = () => { };
			x.waf[wafId].onAfterSend = () => { };
			x.waf[wafId].onBeforeSend = () => { };
			x.waf[wafId].onSave = () => { };
			x.waf[wafId].onAfterSave = () => { };
			x.waf[wafId].onBeforeSave = () => { };
			x.waf[wafId].send = () => { };
			x.waf[wafId].elements = {};								// Enthält sämtliche Felder des Formulars
			x.waf[wafId].props = {};
			x.waf[wafId].addSend = {};
		}
		if (typeof settings !== 'undefined') {
			x.waf[wafId] = Object.assign({}, x.waf[wafId], settings);
		}
	}

	/*
	function sinitField(wafId, fieldId, reference, defaultValue, fieldName) {
		init(wafId);
		x.waf[wafId].elements[fieldId] = {
			"valid": true,
			"initial": "",
			"mandatory": false
		};
		if (typeof defaultValue != 'undefined') {
			set(wafId, fieldId, defaultValue, true);
		}
		if (typeof fieldName != 'undefined') {
			x.waf[wafId].elements[fieldId].name = fieldName;					// Falls gesetzt, wird in "prepare" dieser Wert als Feldname anstelle der ID verwendet
		}
		if (typeof reference != 'undefined') {
			x.waf[wafId].elements[fieldId].reference = reference;
			console.log('Reference: ' + x.waf[wafId].elements[fieldId].reference);
		}
		else {
			console.log('Reference: ' + reference);
		}
	}
	*/

	function initField(wafId, fieldId, reference, defaultValue, fieldName) {
		init(wafId);
		if (typeof x.waf[wafId].elements[fieldId] === 'undefined') {
			x.waf[wafId].elements[fieldId] = {
				"reference": reference,
				"valid": true,
				"initial": "",
				"mandatory": false
			};
			if (typeof defaultValue != 'undefined') {
				set(wafId, fieldId, defaultValue, true);
			}
			if (typeof fieldName != 'undefined') {
				x.waf[wafId].elements[fieldId].name = fieldName;					// Falls gesetzt, wird in "prepare" dieser Wert als Feldname anstelle der ID verwendet
			}
		}
	}

	function isField(wafId, fieldId) {
		return (typeof x.waf[wafId] !== 'undefined' && typeof x.waf[wafId].elements[fieldId] !== 'undefined');
	}

	function isNewWord(wafId, fieldId) {
		const curPos = x.waf[wafId].elements[fieldId].reference.current.selectionStart;
		const curVal = x.waf.get(wafId, fieldId);
		if (curPos === 0 || curVal.substring(curPos - 1, curPos) === ' ') {
			return true;
		}
		return false;
	}

	function get(wafId, fieldId) {
		initField(wafId, fieldId);
		if (isFieldCreated(wafId, fieldId)) {
			if (x.waf[wafId].elements[fieldId].reference.current.type === 'checkbox') {
				return ((x.waf[wafId].elements[fieldId].reference.current.checked) ? 1 : 0);
			}
			else {
				return x.waf[wafId].elements[fieldId].reference.current.value;
			}
		}
		else {
			console.log('Field: ' + fieldId + ' not created');
			return '';
		}
	}

	function isFieldCreated(wafId, fieldId) {
		return (typeof x.waf[wafId] !== 'undefined' && typeof x.waf[wafId].elements[fieldId] !== 'undefined' && typeof x.waf[wafId].elements[fieldId].reference !== 'undefined');
	}

	function getKey(wafId, fieldId, key) {
		initField(wafId, fieldId);
		return x.waf[wafId].elements[fieldId].key;					// Für Select-Felder. Wenn definiert, wird dieser Wert anstelle des Values an den Server gesendet
	}

	function getValid(wafId, fieldId) {
		return x.waf[wafId].elements[fieldId].valid;
	}


	function set(wafId, fieldId, value, initial) {
		const setInitial = (typeof initial === 'undefined') ? false : initial;
		initField(wafId, fieldId);
		const formElement = x.waf[wafId].elements[fieldId].reference.current;
		if (formElement.type === 'checkbox') {
			formElement.checked = value;
		}
		else {
			if (formElement.tagName === 'DIV') {
				formElement.innerHTML = value;
			}
			else {
				formElement.value = value;
			}
		}
		if (setInitial) {
			x.waf[wafId].elements[fieldId].initial = value;
		}
		else {
			x.waf[wafId].onFormChanged();
		}
	}

	function setFields(wafId, fields, initial = true) {
		for (const key in fields) {
			set(wafId, key, fields[key]);
		}
	}

	function setReference(wafId, fieldId, reference) {
		x.waf[wafId].elements[fieldId].reference = reference;
	}

	function setValid(wafId, fieldId, valid) {
		x.waf[wafId].elements[fieldId].valid = valid;
	}

	function setKey(wafId, fieldId, key) {
		x.waf[wafId].elements[fieldId].key = key;					// Für Select-Felder. Wenn definiert, wird dieser Wert anstelle des Values an den Server gesendet
	}

	function checkChanged(wafId) {
		let changed = false;
		let formElement;
		if (mandatoryOk(wafId)) {
			for (const key in x.waf[wafId].elements) {
				formElement = x.waf[wafId].elements[key].reference.current;
				if (formElement.type === 'checkbox') {
					if (x.waf[wafId].elements[key].initial !== formElement.checked) {
						changed = true;
					}
				}
				if (formElement.type === 'text' || formElement.type === 'textarea' || formElement.type === 'select-one') {
					if (get(wafId, key) !== x.waf[wafId].elements[key].initial) {
						changed = true;
					}
				}
			}
		}
		return changed;
	}

	function send(wafId, url, handleResult, handleError) {
		handleError = (typeof handleError === 'undefined') ? () => { } : handleError;
		x.waf[wafId].onBeforeSend();
		// console.log(prepare(wafId));
		axios.post(x.wau.getUrl(url), prepare(wafId))
			.then(result => {
				handleResult(result);
			})
			.catch(function (error) {
				x.wah.addHint('Error in Axios Post: ' + url, false);
				handleError();
			})
	}

	function focus(wafId, fieldId) {
		// console.log('WafId:' + wafId + ':' + x.waf[wafId].elements[fieldId].reference.current.id);
		if (isFieldCreated(wafId, fieldId)) {
			x.waf[wafId].elements[fieldId].reference.current.focus();
		}
	}

	function setCursorPos(wafId, fieldId, start, end) {
		x.waf[wafId].elements[fieldId].reference.current.setSelectionRange(start, end);
		//x.waf[wafId].elements[fieldId].reference.setCursorPosition(1);

	}

	function enable(wafId, fieldId) {
		x.waf[wafId].elements[fieldId].reference.current.disabled = false;
	}

	function disable(wafId, fieldId) {
		x.waf[wafId].elements[fieldId].reference.current.disabled = true;
	}

	function isReadOnly(wafId, fieldId) {
		return x.waf[wafId].elements[fieldId].reference.current.readOnly;
	}

	function setReadOnly(wafId, fieldId, set) {
		x.waf[wafId].elements[fieldId].reference.current.readOnly = set;
	}

	function show(wafId, fieldId) {
		x.waf[wafId].elements[fieldId].reference.current.hidden = false;
	}

	function hide(wafId, fieldId) {
		x.waf[wafId].elements[fieldId].reference.current.hidden = true;
	}

	function setAddSend(wafId, fieldId, value) {
		x.waf[wafId].addSend[fieldId] = value;
	}

	function setSource(wafId, fieldId, source) {
		const formElement = x.waf[wafId].elements[fieldId].reference.current;
		formElement.src = source;
	}

	function mandatory(wafId, fieldId, mandatory) {
		x.waf[wafId].elements[fieldId].mandatory = mandatory;
	}

	function mandatoryOk(wafId) {
		let ok = true;
		let ref;
		for (const key in x.waf[wafId].elements) {
			ref = x.waf[wafId].elements[key].reference.current;
			if (x.waf[wafId].elements[key].mandatory) {
				if (get(wafId, key).trim() === '') {
					if (!ref.className.includes('mandatory')) {
						ref.className = ref.className + ' mandatory';
					}
					ok = false;
				}
				else {
					ref.className = ref.className.replace(" mandatory", "");
				}
			}
		}
		return ok;
	}

	function select(wafId, fieldId) {
		x.waf[wafId].elements[fieldId].reference.current.select();
	}


	function insert(wafId, fieldId, value) {
		const curPos = x.waf[wafId].elements[fieldId].reference.current.selectionStart;
		const curVal = x.waf.get(wafId, fieldId);
		const leftValue = curVal.substring(0, curPos);
		const rightValue = curVal.substring(curPos);
		x.waf.set(wafId, fieldId, leftValue + value + rightValue);
		x.waf[wafId].elements[fieldId].reference.current.selectionStart = curPos;
		x.waf[wafId].elements[fieldId].reference.current.selectionEnd = curPos;
	}

	function insertText(wafId, fieldId, value) {
		const curPos = x.waf[wafId].elements[fieldId].reference.current.selectionStart;
		const curVal = x.waf.get(wafId, fieldId);
		const leftValue = curVal.substring(0, curPos);
		const rightValue = curVal.substring(curPos);
		const newText = leftValue + value + rightValue;
		x.waf.set(wafId, fieldId, newText);
		x.waf.focus(wafId, fieldId);
		x.waf.setCursorPos(wafId, fieldId, curPos + value.length, curPos + value.length);
		// x.wau.postingBackup(x.wad[props.id].wafId, props.answerTo, newText);
	}


	function prepare(wafId) {
		var fields = {};
		var fieldName, formElement;
		for (const key in x.waf[wafId].elements) {
			if (typeof x.waf[wafId].elements[key].reference !== 'undefined') {
				if (typeof x.waf[wafId].elements[key].name === 'undefined') {
					fieldName = key;
				}
				else {
					fieldName = x.waf[wafId].elements[key].name;
				}
				formElement = x.waf[wafId].elements[key].reference.current;
				if (formElement.type === 'checkbox') {
					fields[fieldName] = (formElement.checked) ? "1" : "0";
				}
				else {
					fields[fieldName] = formElement.value;
				}

				// Falls ein Key gesetzt ist, wird dieser anstatt des Field-Values zur Speicherung verwendet
				// Implementiert für Auswahlfelder (FormSelect Komponente)
				if (typeof x.waf[wafId].elements[key].key !== 'undefined') {
					fields[fieldName] = x.waf[wafId].elements[key].key;
				}

			}
		}
		Object.entries(x.waf[wafId].addSend).forEach(([key, value]) => {
			fields[key] = value;
		});
		// console.log(fields);
		return fields;
	}

	return (
		<React.Fragment />
	);

}

